import { ConfigProvider, DatePicker } from 'antd'
import styles from './style.module.scss'
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { getCurrentLanguage } from '@/i18next'

export const DateTimePicker = ({ onChange = () => {}, ...props }) => {
	const lang = getCurrentLanguage()
	const [currentLocale, setCurrentLocale] = useState(null)

	useEffect(() => {
		let mounted = true

		const loadLocale = async () => {
			if (lang === 'rus') {
				const mod = await import('antd/es/locale/ru_RU')
				await import('moment/locale/ru')
				moment.locale('ru')
				if (mounted) setCurrentLocale(mod.default || mod)
			} else {
				const mod = await import('antd/es/locale/kk_KZ')
				await import('moment/locale/kk')
				moment.locale('kk')
				if (mounted) setCurrentLocale(mod.default || mod)
			}
		}

		loadLocale()
		return () => {
			mounted = false
		}
	}, [lang])

	return (
		<ConfigProvider locale={currentLocale}>
			<DatePicker
				showTime
				size="large"
				className={styles.createDateRangePicker}
				format={'DD.MM.YYYY HH:mm'}
				onChange={(value, dateString) => {
					onChange(value, dateString)
				}}
				{...props}
			/>
		</ConfigProvider>
	)
}
